import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
  })
export class CurrentSchoolService {
    currentSchoolId = new ReplaySubject<number>(1);
}
